import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Plants from "../views/Plants.vue";
import PlantDetail from "../views/PlantDetail.vue";
import PlantSettings from "../views/PlantSettings.vue";
import Products from "../views/Products.vue";
import ProductDetail from "../views/ProductDetail.vue";
import ProductSettings from "../views/ProductSettings.vue";
import Greenhouses from "../views/Greenhouses.vue";
import GreenhouseDetail from "../views/GreenhouseDetail.vue";
import GreenhouseDepartment from "../views/GreenhouseDepartment.vue";
import PlanningTool from "../views/PlanningTool.vue";
import PL from "../views/PL.vue";
import CostManagement from "../views/CostManagement.vue";
import CostRates from "../views/CostRates.vue";
import OperatingCosts from "../components/cost/OperatingCosts.vue";
import PlantFixedCostTemplates from "../components/cost/PlantFixedCostTemplates.vue";
import ProductFixedCostTemplates from "../components/cost/ProductFixedCostTemplates.vue";
import GrowthTasks from "../views/GrowthTasks.vue";
import GrowthTaskDetail from "../views/GrowthTaskDetail.vue";
import GrowthTaskSettings from "../views/GrowthTaskSettings.vue";
import Inventory from "../views/Inventory.vue";
import Orders from "../views/Orders.vue";
import OrderDetail from "../views/OrderDetail.vue";
// import Picklist from "../views/Picklist.vue";
// import PickDetail from "../views/PickDetail.vue";
import Suppliers from "../views/Suppliers.vue";
import Customers from "../views/Customers.vue";
import TenantUserGroups from "../views/TenantUserGroups.vue";
import TenantUserGroupDetail from "../views/TenantUserGroupDetail.vue";
import TenantUsers from "../views/TenantUsers.vue";
// customized modules
import InventoryByPlant from "../components/customized/InventoryByPlant.vue";
import InventoryByWeek from "../components/customized/InventoryByWeek.vue";
import InventoryByWeekSum from "../components/customized/InventoryByWeekSum.vue";
import GrowthTaskPhases from "../views/GrowthTaskPhases.vue"

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/plants",
        name: "plants",
        component: Plants,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/plant/:id",
        name: "plant-detail",
        component: PlantDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/plantsettings",
        name: "plant-settings",
        component: PlantSettings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/products",
        name: "products",
        component: Products,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/product/:id",
        name: "product-detail",
        component: ProductDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/productsettings",
        name: "product-settings",
        component: ProductSettings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/greenhouses",
        name: "greenhouses",
        component: Greenhouses,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/greenhouse/:id",
        name: "greenhouse-detail",
        component: GreenhouseDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/department/:id",
        name: "greenhouse-department",
        component: GreenhouseDepartment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/planningtool",
        name: "planningtool",
        component: PlanningTool,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/pl",
        name: "pl",
        component: PL,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/costmanagement",
        name: "costmanagement",
        component: CostManagement,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/costrates",
        name: "costrates",
        component: CostRates,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/operatingcosts",
        name: "operatingcosts",
        component: OperatingCosts,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/plantfixedcosttemplates",
        name: "plantfixedcosttemplates",
        component: PlantFixedCostTemplates,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/productfixedcosttemplates",
        name: "productfixedcosttemplates",
        component: ProductFixedCostTemplates,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/growthtasks",
        name: "growthtasks",
        component: GrowthTasks,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/growthtask/:id",
        name: "growthtask-detail",
        component: GrowthTaskDetail,
        meta: {
            requiresAuth: true
        }
    },
     {
         path: "/growthtaskphases",
         name: "growthtaskphases",
         component: GrowthTaskPhases,
         meta: {
             requiresAuth: true
         }
     },
    {
        path: "/growthtasksettings",
        name: "growth-task-settings",
        component: GrowthTaskSettings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/inventory",
        name: "inventory",
        component: Inventory,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/orders",
        name: "orders",
        component: Orders,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/order/:id",
        name: "order-detail",
        component: OrderDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/suppliers",
        name: "suppliers",
        component: Suppliers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/customers",
        name: "customers",
        component: Customers,
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: "/users",
    //     name: "users",
    //     component: UserList,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: "/groups",
        name: "groups",
        component: TenantUserGroups,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/group/:id",
        name: "group-detail",
        component: TenantUserGroupDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/users",
        name: "users",
        component: TenantUsers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/customized/inventorybyplant",
        name: "inventory-by-plant",
        component: InventoryByPlant,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/customized/inventorybyweeksum",
        name: "inventory-by-week-sum",
        component: InventoryByWeekSum,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/customized/inventorybyweek/:yearWeek",
        name: "inventory-by-week",
        component: InventoryByWeek,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue")
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters["user/isLoggedIn"]) {
            next();
        } else {
            next({ name: "login", query: { redirect: to.path } });
        }
    } else {
        next();
    }
});

export default router;
